import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "./models";
import * as Actions from "../actions";
import {
  dataTriagemTipoReducer,
  dataVariaveisTriagemStatusReducer,
  dataTriagemIndicadoresTMSReducer,
  dataTriagemIndicadoresCodigoOcorrenciaReducer,
  dataTriagemIndicadoresTipoReducer,
  dataTriagemIndicadoresTransportadoraReducer,
  dataTriagemOcorrenciasReducer,
} from "../reducers";

const initialState: InitialState = {
  dataTriagem: {
    tipos: {
      data: [],
    },
    indicadores: {
      data: {
        transportadoras: [],
        tipoValidacao: [],
        pontos: [],
      },
    },
    ocorrencias: {
      data: [],
      requestGetParams: {},
      pagination: {
        page: 1,
        rowsPerPage: 15,
        totalPages: 0,
        totalItems: 0,
      },
    },
    variaveis: {
      data: [],
    },
  },
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Triagem",
        index: 0,
        active: true,
        name: "triagem",
      },
    ],
  },
  rowsTable: {
    open: false
  }
};

const triagemSlice = createSlice({
  name: "triagemApp/triagem",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
    },
    closeAllRows: (state, action) => {
      state.rowsTable.open = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      Actions.getDataTriagemTipo.fulfilled,
      dataTriagemTipoReducer
    );
    builder.addCase(
      Actions.getVariaveisTriagemStatus.fulfilled,
      dataVariaveisTriagemStatusReducer
    );
    builder.addCase(
      Actions.getDataTriagemIndicadoresTMS.fulfilled,
      dataTriagemIndicadoresTMSReducer
    );
    builder.addCase(
      Actions.getDataTriagemIndicadoresCodigoOcorrencia.fulfilled,
      dataTriagemIndicadoresCodigoOcorrenciaReducer
    );
    builder.addCase(
      Actions.getDataTriagemIndicadoresTipo.fulfilled,
      dataTriagemIndicadoresTipoReducer
    );
    builder.addCase(
      Actions.getDataTriagemIndicadoresTransportadora.fulfilled,
      dataTriagemIndicadoresTransportadoraReducer
    );
    builder.addCase(
      Actions.getDataTriagemOcorrencias.fulfilled,
      dataTriagemOcorrenciasReducer
    );
  },
});

export const { changeTab, closeAllRows } = triagemSlice.actions;

export default triagemSlice.reducer;
